import React from "react";
import { Link } from "react-router-dom";
import { AlertTriangle, ArrowRight } from "lucide-react";
import type { OverviewNeedsAttention } from "../../../types/dashboard";
import { formatRetreatDates } from "./format";
import styles from "../Dashboard.module.scss";

export default function NeedsAttentionPanel({
  items,
}: {
  items: OverviewNeedsAttention[];
}): JSX.Element {
  return (
    <section className={styles.panel}>
      <div className={styles.panelHeader}>
        <div className={styles.panelTitleWrap}>
          <span className={styles.panelGlyph} style={{ background: "#fff3d6", color: "#b45309" }}>
            <AlertTriangle size={16} />
          </span>
          <div>
            <h3 className={styles.panelTitle}>Needs Attention</h3>
            <p className={styles.panelKicker}>Closing work still open</p>
          </div>
        </div>
        <Link to="/manageRetreat" className={styles.panelLink}>
          Closing <ArrowRight size={14} />
        </Link>
      </div>
      {items.length === 0 ? (
        <div className={styles.empty}>
          <p className="mb-0">No retreats currently in closing.</p>
        </div>
      ) : (
        <div className={styles.list}>
          {items.map((item) => {
            const warn = item.closingTone === "warning";
            const missing = (item.closingMissing || []).slice(0, 2).join(", ");
            return (
              <Link
                key={item.id}
                to={`/retreatRoster?retreatId=${item.id}`}
                className={`${styles.attentionRow} ${warn ? styles.warn : ""}`}
              >
                <span
                  className={styles.rowIcon}
                  style={{ background: warn ? "#fff3d6" : "#e8f3fc" }}
                >
                  <AlertTriangle size={18} color={warn ? "#8a6300" : "#285d8f"} />
                </span>
                <div className={styles.rowBody}>
                  <p className={styles.rowTitle}>
                    {item.parishName || item.title || `Retreat ${item.id}`}
                  </p>
                  <p className={styles.rowMeta}>
                    <span>{formatRetreatDates(item.dateFrom, item.dateTo)}</span>
                    {item.daysSinceRetreat ? (
                      <span>{item.daysSinceRetreat}d since weekend</span>
                    ) : null}
                    {missing ? <span>{missing}</span> : null}
                  </p>
                </div>
                <div className={styles.rowStats}>
                  <span className={warn ? `${styles.badge} ${styles.badgeWarn}` : styles.badge}>
                    {item.closingPercent || 0}% complete
                  </span>
                  <div className={styles.progressWrap}>
                    <div
                      className={`${styles.progressBar} ${warn ? styles.progressBarWarn : ""}`}
                      style={{ width: `${Math.min(100, Number(item.closingPercent || 0))}%` }}
                    />
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      )}
    </section>
  );
}
